import { render, staticRenderFns } from "./ExpiredPurchaserToken.vue?vue&type=template&id=57c32f75&scoped=true&"
import script from "./ExpiredPurchaserToken.vue?vue&type=script&lang=js&"
export * from "./ExpiredPurchaserToken.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredPurchaserToken.vue?vue&type=style&index=0&id=57c32f75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c32f75",
  null
  
)

export default component.exports